/**
 * AI.GEN lines=1-41
 * 国家代码配置
 * 支持通过 URL 参数 countryCode 切换国家（仅非正式环境）
 */
import { type ICountryCode } from '@/components/enum';

export type { ICountryCode };

/**
 * 获取国家代码
 * - 非正式环境（test/dev）：优先级 URL 参数 > 环境变量 > 默认值
 * - 正式环境（beta/release）：优先级 环境变量 > 默认值（禁用 URL 参数）
 */
/**
 * AI.GEN lines=1-12
 * 获取国家代码
 */
const getCountryCode = (): ICountryCode => {
  const countryList: ICountryCode[] = [
    'CN',
    'JP',
    'KR',
    'CA',
    'USA',
    'AUS',
    'NZD',
    'UK',
    'EUR',
    'SG',
  ];

  // 获取当前环境
  const env = process.env.environment;

  // 从环境变量获取国家代码
  const envCountry = process.env.country?.toUpperCase();

  let urlCountry: string | undefined;

  // 只在非正式环境（test/dev）允许使用 URL 参数
  // beta 和 release 环境禁用 URL 参数，确保安全性
  if (env !== 'beta' && env !== 'release') {
    const urlParams = new URLSearchParams(window.location.search);
    urlCountry = urlParams.get('countryCode')?.toUpperCase();
  }

  // 优先级：URL 参数（仅非正式环境）> 环境变量 > 默认值 'CN'
  const code = (urlCountry || envCountry || 'CN') as ICountryCode;

  return countryList.includes(code) ? code : 'CN';
};

export const countryCode = getCountryCode();

/**
 * 默认时区（用于城市时区的兜底值）
 */
export const defaultTimezone = 'America/Toronto';
